import { Divider, Flex, FormControl, Grid, ModalBody, ModalHeader, Text, Box, ModalCloseButton, Textarea, } from "@chakra-ui/react";
import MyDiv from "./holdCard.style";
import { CustomButton, CustomToast } from "../../../../../components";
import { useState } from "react";
import { useFetch } from "../../../../../hooks/useFetch";

type HoldCardProps = {
  onClose: () => void;
  candidateDetail: any;
  interviewResult: number;
  reload: boolean;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;
};

const HoldCard = ({ onClose, candidateDetail, interviewResult, reload, setReload }: HoldCardProps) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [holdReason, setHoldReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleHoldedSubmit = async () => {
    if (!candidateDetail) {
      addToast({ message: "Candidate details not found.", status: "error" });
      return;
    }
    if (holdReason.trim() === "") {
      addToast({ message: "Please provide a reason before submitting.", status: "warning" });
      return;
    }

    const payload = {
      candidate_Id: candidateDetail.id,
      interview_Result: interviewResult ?? 7, // 7= Hold Status
      hold_Reason: holdReason.trim(),
    };

    try {
      setIsSubmitting(true);
      const response = await fetchApi("Candidate/interviewStatusChange  ", "POST", payload, "", "");
      if (response) {
        addToast({ message: "Candidate put on hold successfully.", status: "success" });
        setReload(!reload);
        onClose();

      }
    } catch (error) {
      addToast({ message: "Failed to update candidate status. Please try again.", status: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <MyDiv>
      <ModalHeader textAlign="center" className="font-poppins text_medium text_xxl">
        Candidate Hold the Offer
      </ModalHeader>
      <ModalCloseButton />
      <Divider />
      <ModalBody>
        <Grid gap={4}>
          <Flex justifyContent="space-between">
            <Text className="font-poppins text_md text_medium">Candidate Name</Text>
            <Text className="font-poppins text_md text_regular">{candidateDetail?.candidate_Name}</Text>
          </Flex>
          <Flex justifyContent="space-between">
            <Text className="font-poppins text_md text_medium">Candidate Email</Text>
            <Text className="font-poppins text_md text_regular">{candidateDetail?.email}</Text>
          </Flex>

          <FormControl>
            <Text className="font-poppins text_md text_medium" mb={1}>Reason</Text>
            <Textarea value={holdReason} onChange={(e) => setHoldReason(e.target.value)} placeholder="Explain your reason" rows={13} resize="vertical" className="font-poppins text_md text_regular" />
          </FormControl>

          <Box display="flex" justifyContent="flex-end" mt={4}>
            <CustomButton title={isSubmitting ? "Submitting..." : "Submit"} className="btn font-poppins text_sm text_medium" onClick={handleHoldedSubmit} isDisabled={isSubmitting} />
          </Box>
        </Grid>
      </ModalBody>
    </MyDiv>
  );
};

export default HoldCard;
